<script setup lang="ts">
import Icon from "./Icon.vue";
import { useQuery } from "@tanstack/vue-query";

const props = defineProps<{ theme: string }>();
const { $trpc } = useNuxtApp();

const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const { data: mediaSponsor, isSuccess } = useQuery({
  queryKey: ["getAdvertiserByTheme", props.theme],
  queryFn: () =>
    $trpc.getAdvertiserByTheme.query({ advertiserTheme: props.theme }),
});
</script>

<template>
  <div class="flex items-center gap-2 shrink-0">
    <div class="w-6">
      <Icon :show-tooltip="false" :theme="theme" />
    </div>
    {{ capitalize(theme) }}
    <tippy v-if="isSuccess" to="parent" :hide-on-click="false" interactive>
      <strong>Media sponsor:</strong> {{ mediaSponsor?.mediaSponsorName }}<br />
      <strong>Country:</strong> {{ mediaSponsor?.mediaSponsorCountry }}
      <br />
      <strong>Contact:</strong>
      <a
        target="_blank"
        :href="`mailto:${mediaSponsor?.mediaSponsorEmailContact}`"
        class="underline"
        >{{ mediaSponsor?.mediaSponsorEmailContact }}</a
      >
    </tippy>
  </div>
</template>
